/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Android_TextInputs */

const en_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const id_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ms_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ca_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const cs_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const da_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const de_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const et_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const es_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const fr_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const hr_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const it_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const lv_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const lt_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Android“`)
};

const hu_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const nl_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const nb_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const pl_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const pt_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ro_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const sk_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const sl_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const fi_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const sv_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const vi_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const tr_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const el_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const bg_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ru_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const sr_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const uk_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ka_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const hi_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const th_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const ko_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const zh_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const zh_tw_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android 版`)
};

const ja_payment_android_text = /** @type {(inputs: Payment_Android_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

/**
* | output |
* | --- |
* | "Android" |
*
* @param {Payment_Android_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const payment_android_text = /** @type {((inputs?: Payment_Android_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Android_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_payment_android_text(inputs)
	if (locale === "ms") return ms_payment_android_text(inputs)
	if (locale === "ca") return ca_payment_android_text(inputs)
	if (locale === "cs") return cs_payment_android_text(inputs)
	if (locale === "da") return da_payment_android_text(inputs)
	if (locale === "de") return de_payment_android_text(inputs)
	if (locale === "et") return et_payment_android_text(inputs)
	if (locale === "es") return es_payment_android_text(inputs)
	if (locale === "fr") return fr_payment_android_text(inputs)
	if (locale === "hr") return hr_payment_android_text(inputs)
	if (locale === "it") return it_payment_android_text(inputs)
	if (locale === "lv") return lv_payment_android_text(inputs)
	if (locale === "lt") return lt_payment_android_text(inputs)
	if (locale === "hu") return hu_payment_android_text(inputs)
	if (locale === "nl") return nl_payment_android_text(inputs)
	if (locale === "nb") return nb_payment_android_text(inputs)
	if (locale === "pl") return pl_payment_android_text(inputs)
	if (locale === "pt") return pt_payment_android_text(inputs)
	if (locale === "ro") return ro_payment_android_text(inputs)
	if (locale === "sk") return sk_payment_android_text(inputs)
	if (locale === "sl") return sl_payment_android_text(inputs)
	if (locale === "fi") return fi_payment_android_text(inputs)
	if (locale === "sv") return sv_payment_android_text(inputs)
	if (locale === "vi") return vi_payment_android_text(inputs)
	if (locale === "tr") return tr_payment_android_text(inputs)
	if (locale === "el") return el_payment_android_text(inputs)
	if (locale === "bg") return bg_payment_android_text(inputs)
	if (locale === "ru") return ru_payment_android_text(inputs)
	if (locale === "sr") return sr_payment_android_text(inputs)
	if (locale === "uk") return uk_payment_android_text(inputs)
	if (locale === "ka") return ka_payment_android_text(inputs)
	if (locale === "hi") return hi_payment_android_text(inputs)
	if (locale === "th") return th_payment_android_text(inputs)
	if (locale === "ko") return ko_payment_android_text(inputs)
	if (locale === "zh") return zh_payment_android_text(inputs)
	if (locale === "zh-tw") return zh_tw_payment_android_text(inputs)
	if (locale === "ja") return ja_payment_android_text(inputs)
	return en_payment_android_text(inputs)
});